import React from 'react';
import { FormattedHTMLMessage, injectIntl } from 'react-intl';
import Route from 'react-router/Route';
import Section from '../components/Section';
import Chart from '../components/worldmap/Chart';
import projects from '../data/projects';

/*const projects = [
  {'id':'VE1', 'value':100, 'color':'#86a965', 'latitude':8, 'longitude':-66 },
  {'id':'VE2', 'value':100, 'color':'#86a965', 'latitude':8, 'longitude':-60 },
  {'id':'IT', 'value':100, 'color':'#d8854f', 'latitude':42.8333, 'longitude':12.8333 },
  {'id':'KZ1', 'value':100, 'color':'#eea638', 'latitude':48, 'longitude':68 },
  {'id':'KZ2', 'value':100, 'color':'#eea638', 'latitude':48, 'longitude':60 },
  {'id':'KZ3', 'value':100, 'color':'#eea638', 'latitude':48, 'longitude':60 },
  {'id':'KZ4', 'value':100, 'color':'#eea638', 'latitude':46, 'longitude':60 },
  {'id':'KZ5', 'value':100, 'color':'#eea638', 'latitude':46, 'longitude':58 },
  {'id':'KZ6', 'value':100, 'color':'#eea638', 'latitude':44, 'longitude':56 },
  {'id':'KZ7', 'value':100, 'color':'#eea638', 'latitude':48, 'longitude':60 },
  {'id':'KZ8', 'value':100, 'color':'#eea638', 'latitude':42, 'longitude':60 },
  {'id':'KZ9', 'value':100, 'color':'#66ccff', 'latitude':47.07, 'longitude':52.5359 },
  {'id':'DZ1', 'value':100, 'color':'#de4c4f', 'latitude':28, 'longitude':3 },
  {'id':'DZ2', 'value':100, 'color':'#de4c4f', 'latitude':26, 'longitude':3 },
  {'id':'DZ3', 'value':100, 'color':'#de4c4f', 'latitude':28, 'longitude':1 },
  {'id':'EG1', 'value':100, 'color':'#de4c4f', 'latitude':27, 'longitude':34 },
  {'id':'EG2', 'value':100, 'color':'#de4c4f', 'latitude':30, 'longitude':32 },
  {'id':'EG3', 'value':100, 'color':'#de4c4f', 'latitude':24, 'longitude':28 },
  {'id':'EG4', 'value':100, 'color':'#de4c4f', 'latitude':24, 'longitude':28 },
  {'id':'EG5', 'value':100, 'color':'#de4c4f', 'latitude':27, 'longitude':30 },
  {'id':'EG6', 'value':100, 'color':'#de4c4f', 'latitude':26, 'longitude':31 },
  {'id':'EG7', 'value':100, 'color':'#de4c4f', 'latitude':26, 'longitude':31 },
  {'id':'CD1', 'value':100, 'color':'#de4c4f', 'latitude':0, 'longitude':20 },
  {'id':'CD2', 'value':100, 'color':'#de4c4f', 'latitude':0, 'longitude':28 },
  {'id':'TN1', 'value':100, 'color':'#de4c4f', 'latitude':34, 'longitude':9 },
  {'id':'TN2', 'value':100, 'color':'#de4c4f', 'latitude':34, 'longitude':0 },
];*/

const Projects = React.createClass({
  getInitialState(){
    return {
      selectedProject : null
    }
  },
  render(){
    const { project, intl } = this.props;
    const { selectedProject } = this.state;
    return (
      <Section id="projects">
        {/* la key nel chart serve per farlo rirenderizzare ogni volta che viene girato lo schermo nei telefoni */}
        <Chart
          key={ typeof window != 'undefined' ? ( window.innerWidth + 1 ) * window.innerHeight : 0 }
          style={{ width : "100%", height : "100%" }}
          type="geo"
          events={[
            {
              type: 'click',
              handler: (e) => {
                if(e.data){
                  this.setState({ selectedProject : e.data.id })
                }
              }
            }
          ]}
          options={{
            geo: {
              //roam : true,
              selectedMode : 'single',
              zoom : 2.2,
              map: 'world',
              label: {
                normal: {
                  show: false
                },
                emphasis: {
                  show: true,
                  textStyle : {
                    fontFamily : 'Open Sans',
                    color: 'white',
                    //fontWeight : 'bold'
                  }
                }
              },
              itemStyle: {
                normal: {
                  areaColor: 'rgba(42, 51, 61, 0.6)',
                  borderColor : 'rgba(0,0,0,0.5)'
                },
                emphasis: {
                  areaColor: 'rgba(42, 51, 61, 0.6)'
                }
              },
            },
            series : [
              {
                type: 'scatter',
                coordinateSystem: 'geo',
                data: projects
                  .map((item,index) => {
                    return {
                      id : index,
                      name: `<div>
                          <p>Project: ${ item.project }</p>
                          <p>Contractor: ${ item.contractor }</p>
                          <p>Final Client: ${ item.finalClient }</p>
                          <p>Destination: ${ item.destination }</p>
                          <p>Supply Scope: ${ item.supplyScope }</p>
                        </div>`
                      ,
                      value: [
                        item.longitude,
                        item.latitude,
                        item.value
                      ],
                      label: {
                        normal: {
                          show: false
                        },
                        emphasis: {
                          show: false
                        }
                      },
                      itemStyle: {
                          normal: {
                              color: item.color
                          }
                      }
                    };
                })
              }
            ]
          }}
          />
        {
          (selectedProject || selectedProject == 0 )  &&
            <Project item={ projects[selectedProject] } />
        }
      </Section>
    )
  }
})


const Project = ({ item }) => (
  <div className="project">
    <div>
      <p>Project: { item.project }</p>
      <p>Contractor: { item.contractor }</p>
      <p>Final Client: { item.finalClient }</p>
      <p>Destination: { item.destination }</p>
      <p>Supply Scope: { item.supplyScope }</p>
    </div>
  </div>
)

export default injectIntl( Projects );



// WEBPACK FOOTER //
// ./src/sections/Projects.js